import { render, staticRenderFns } from "./HighlightPunctuation.vue?vue&type=template&id=473fb520&scoped=true&lang=html&"
import script from "./HighlightPunctuation.vue?vue&type=script&lang=js&"
export * from "./HighlightPunctuation.vue?vue&type=script&lang=js&"
import style0 from "./HighlightPunctuation.vue?vue&type=style&index=0&id=473fb520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473fb520",
  null
  
)

export default component.exports